<div class="color-component cursor-pointer py-4 px-4" [class.selected]="isSelected" (click)="onSelect()">
<!-- Primera imagen (superior) -->
    <div class="preview-image-container top-image">
        <img
            [src]="mainImage"
            class="preview-image"
            loading="lazy"
        />
    </div>

<!-- Texto central -->
    <div class="middle-text-container">
        <div class="text-content">
            <h4 class="preview-title">
                {{ name }}
            </h4>
        </div>
    </div>

<!-- Segunda imagen (inferior) -->
    <div class="preview-image-container top-image">
        <div class="image-wrapper group mb-2" style="display: flex; align-items: center; gap: 0.5rem; justify-content: space-between;">
            <img
            [src]="'assets/icons/brands/' + brand.toLowerCase() + '-black.svg'"
            [alt]="brand"
            class="brand-logo"
            loading="lazy"
            />
            <div style="display: flex; gap: 0.25rem;">
              <span class="text-sm text-gray-400">{{ 'my_displays.discount' | translate }}</span>
              <span class="text-sm" style="color: #2574A9;">{{ discount ? discount : '0%' }}</span>
            </div>
        </div>
        <div *ngIf="isNew" style="display: flex; gap: 0.5rem;">
            <app-badge-status statusText="{{ ('new' | translate)}}" [iconClass]="'delivered'"></app-badge-status>
        </div>
    </div>
</div>
